export default {"src":"/_next/static/image/public/images/ic_delete_white.9fc0f06ffb8828d5f6b0ffbb0b52ee99.svg","height":15,"width":14};